import { Button, Table, Pagination } from 'antd'
import Buttonbar from '../../components/ButtonBar'
import Style from './taskcenter.module.scss'
import usetaskHooks from './hooks'
import { QuestionCircleOutlined } from '@ant-design/icons'

// 任务中心
const Taskcenter = () => {
  const {
    dataSource,
    pages,
    onChange,
    onClickFile,
    onClickDetail,
    onRefresh,
    closeTab,
    setChangeSize,
    dataSourceLoading,
  } = usetaskHooks()

  return (
    <div style={{ padding: '0 20px' }}>
      <Buttonbar onRefresh={onRefresh}>
        <Button type="link" size="small" onClick={closeTab}>
          关闭
        </Button>
      </Buttonbar>
      <div className={Style.box} style={{ height: `calc(100vh - ${150}px)` }}>
        <div className={Style.tableHead}>【任务列表】</div>
        <Table
          dataSource={dataSource.data}
          className={Style['tablescroll']}
          bordered={false}
          rowKey="id"
          scroll={{ y: `calc(100vh - ${200}px)` }}
          style={{ height: `calc(100vh - ${200}px)`, borderColor: '#cccccc' }}
          loading={dataSourceLoading}
          pagination={false}
          onRow={() => ({
            className: Style['table-row'],
          })}
        >
          <Table.Column
            title="状态"
            width={80}
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(b: any) => {
              // 0 执行中、1 失败、2 成功
              let text = ''
              let classname = Style.processingicon
              if (b.state === '3') {
                text = '进行中'
                classname = Style.processingicon
              }
              if (b.state === '2') {
                text = '失败'
                classname = Style.erroricon
              }
              if (b.state === '1') {
                text = '成功'
                classname = Style.successicon
              }
              return (
                <div className={Style.liststate}>
                  <div
                    className={`${Style.stateicon} ${classname}`}
                    data-text={text}
                  ></div>
                </div>
              )
            }}
          />
          <Table.Column
            dataIndex="type"
            title="类型"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(a: string, b: any) =>
              b.state === '3' ? (
                b.type
              ) : (
                <span className="primaryBtn" onClick={() => onClickDetail(b)}>
                  {b.type}
                </span>
              )
            }
          />
          <Table.Column
            dataIndex="code"
            title="任务编码"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="createTime"
            title="创建时间"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(text: string, record: any) => (
              <>
                {text || '-'}
                <span
                  style={{ marginLeft: '3px' }}
                  title={
                    record.startTime
                      ? `开始时间: ${record.startTime}`
                      : '服务器资源筹备中……请耐心等待~'
                  }
                >
                  <QuestionCircleOutlined />
                </span>
              </>
            )}
          />
          <Table.Column
            dataIndex="usedTime"
            title="已用时"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="remainTime"
            title="预估剩余时间"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="totalDetailCount"
            title="成功/总行数"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(a: string, b: any) => `${b.successRow}/${b.totalRow}`}
          />
          <Table.Column
            dataIndex="completeTime"
            title="完成时间"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="fileUrl"
            title="执行文件"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(a: string, b: any) => (
              <span className="primaryBtn" onClick={() => onClickFile(b)}>
                {b.fileName}
              </span>
            )}
          />
        </Table>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div></div>
        <Pagination
          showSizeChanger
          showQuickJumper
          pageSize={pages.pageSize}
          pageSizeOptions={['10', '20', '30', '50', '100', '200', '500']}
          total={dataSource.total}
          showTotal={(total) => `共 ${total} 条`}
          current={pages.pageNo}
          size="small"
          onShowSizeChange={(current: number, size: number) => {
            setChangeSize(current, size)
          }}
          onChange={(page: number, pageSize?: number) => {
            onChange(page, pageSize)
          }}
        />
      </div>
    </div>
  )
}

export default Taskcenter
import { Button, Table, Pagination } from 'antd'
import Buttonbar from '../../components/ButtonBar'
import Style from './taskcenter.module.scss'
import usetaskHooks from './hooks'
import { QuestionCircleOutlined } from '@ant-design/icons'

// 任务中心
const Taskcenter = () => {
  const {
    dataSource,
    pages,
    onChange,
    onClickFile,
    onClickDetail,
    onRefresh,
    closeTab,
    setChangeSize,
    dataSourceLoading,
  } = usetaskHooks()

  return (
    <div style={{ padding: '0 20px' }}>
      <Buttonbar onRefresh={onRefresh}>
        <Button type="link" size="small" onClick={closeTab}>
          关闭
        </Button>
      </Buttonbar>
      <div className={Style.box} style={{ height: `calc(100vh - ${150}px)` }}>
        <div className={Style.tableHead}>【任务列表】</div>
        <Table
          dataSource={dataSource.data}
          className={Style['tablescroll']}
          bordered={false}
          rowKey="id"
          scroll={{ y: `calc(100vh - ${200}px)` }}
          style={{ height: `calc(100vh - ${200}px)`, borderColor: '#cccccc' }}
          loading={dataSourceLoading}
          pagination={false}
          onRow={() => ({
            className: Style['table-row'],
          })}
        >
          <Table.Column
            title="状态"
            width={80}
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(b: any) => {
              // 0 执行中、1 失败、2 成功
              let text = ''
              let classname = Style.processingicon
              if (b.state === '3') {
                text = '进行中'
                classname = Style.processingicon
              }
              if (b.state === '2') {
                text = '失败'
                classname = Style.erroricon
              }
              if (b.state === '1') {
                text = '成功'
                classname = Style.successicon
              }
              return (
                <div className={Style.liststate}>
                  <div
                    className={`${Style.stateicon} ${classname}`}
                    data-text={text}
                  ></div>
                </div>
              )
            }}
          />
          <Table.Column
            dataIndex="type"
            title="类型"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(a: string, b: any) =>
              b.state === '3' ? (
                b.type
              ) : (
                <span className="primaryBtn" onClick={() => onClickDetail(b)}>
                  {b.type}
                </span>
              )
            }
          />
          <Table.Column
            dataIndex="code"
            title="任务编码"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="createTime"
            title="创建时间"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(text: string, record: any) => (
              <>
                {text || '-'}
                <span
                  style={{ marginLeft: '3px' }}
                  title={
                    record.startTime
                      ? `开始时间: ${record.startTime}`
                      : '服务器资源筹备中……请耐心等待~'
                  }
                >
                  <QuestionCircleOutlined />
                </span>
              </>
            )}
          />
          <Table.Column
            dataIndex="usedTime"
            title="已用时"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="remainTime"
            title="预估剩余时间"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="totalDetailCount"
            title="成功/总行数"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(a: string, b: any) => `${b.successRow}/${b.totalRow}`}
          />
          <Table.Column
            dataIndex="completeTime"
            title="完成时间"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
          />
          <Table.Column
            dataIndex="fileUrl"
            title="执行文件"
            ellipsis
            onCell={() => ({
              className: Style['table-cell'],
            })}
            render={(a: string, b: any) => (
              <span className="primaryBtn" onClick={() => onClickFile(b)}>
                {b.fileName}
              </span>
            )}
          />
        </Table>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div></div>
        <Pagination
          showSizeChanger
          showQuickJumper
          pageSize={pages.pageSize}
          pageSizeOptions={['10', '20', '30', '50', '100', '200', '500']}
          total={dataSource.total}
          showTotal={(total) => `共 ${total} 条`}
          current={pages.pageNo}
          size="small"
          onShowSizeChange={(current: number, size: number) => {
            setChangeSize(current, size)
          }}
          onChange={(page: number, pageSize?: number) => {
            onChange(page, pageSize)
          }}
        />
      </div>
    </div>
  )
}

export default Taskcenter
